import * as $ from 'jquery';
const compareValues = (a, b) => {
    // return -1/0/1 based on what you "know" a and b
    // are here. Numbers, text, some custom case-insensitive
    // and natural number ordering, etc. That's up to you.
    // A typical "do whatever JS would do" is:
    if (!isNaN(a) && !isNaN(b)) {
        // convert to numbers
        a = new Number(a);
        b = new Number(b);
    }
    return (a < b) ? -1 : (a > b) ? 1 : 0;
};
// Sortable table: allow sorting by column
//      table must has .table-sortable class
//      add data-toggle="sortable" to th to allow sorting on column
// To allow sorting to formatted values such as date or money
//      add real value to each td data-sortable-value="2020-03-06 18:35:29"
//      <td data-sortable-value="2020-02-01">01/02/2020</td>
//      <td data-sortable-value="12.56">$12.56</td>
class SortableTable {
    constructor(table) {
        this.sortableColumns = [];
        this.init = () => {
            // click event: perform sorting
            this.sortableColumns.forEach(column => {
                column.element.addEventListener("click", (e) => {
                    e.preventDefault();
                    this._sorting(column);
                });
            });
        };
        this._sorting = (column) => {
            let sortParamete = 0;
            // add sort state
            if (column.element.classList.contains("asc")) {
                // descending
                sortParamete = -1;
                column.element.classList.remove("asc");
                column.element.classList.add("desc");
            }
            else {
                // ascending
                sortParamete = 1;
                column.element.classList.remove("desc");
                column.element.classList.add("asc");
            }
            // remove sort state from other column
            this.sortableColumns.forEach(otherColumn => {
                if (otherColumn.index != column.index) {
                    otherColumn.element.classList.remove("asc", "desc");
                }
            });
            // cell query string
            let qs = `td:nth-child(${column.index + 1}`;
            // sorting
            // get all the rows in this table:
            let rows = Array.from(this.table.querySelectorAll('tbody tr'));
            rows.sort((r1, r2) => {
                // get each row's relevant column
                let value1 = this._tdValue(r1.querySelector(qs));
                let value2 = this._tdValue(r2.querySelector(qs));
                // and then effect sorting by comparing their content:
                return compareValues(value1, value2) * sortParamete;
            });
            // clear tbody
            this.tableBody.innerHTML = "";
            // re-render rows
            rows.forEach(row => this.tableBody.appendChild(row));
        };
        this._tdValue = (td) => {
            let value = td.textContent.trim();
            // get data-sortable-value if possible
            const sortableValue = td.getAttribute("data-sortable-value");
            if (sortableValue && sortableValue.length > 0) {
                value = sortableValue;
            }
            return value;
        };
        this.table = table;
        this.tableBody = table.querySelector("tbody");
        // get sortable columns
        [].slice.call(this.table.querySelectorAll("thead th")).forEach((element, index) => {
            if (element.getAttribute('data-toggle') === "sortable") {
                this.sortableColumns.push({ element, index });
            }
        });
    }
}
[].slice.call(document.querySelectorAll('.table-sortable')).forEach((element) => {
    new SortableTable(element).init();
});
// editable table
$('.table-editable tbody')
    .on('focus', 'input:not([type="hidden"])', function () {
    // editing state
    $(this).closest("tr").addClass("tr-editing");
})
    .on('blur', 'input:not([type="hidden"])', function () {
    // read-only state
    $(this).closest("tr").removeClass("tr-editing");
});
const newRecordTemplate = $('.table-editable .table-editable--template').remove();
// add new record
$('[js-new-record]').click(function (e) {
    e.preventDefault();
    // record id
    //const newRecordIndex = uuidv4();
    const newRecordIndex = $(".table-editable tbody tr").length;
    // template
    const newRecord = newRecordTemplate.clone().removeClass('table-editable--template');
    // replace with new Id
    newRecord.find("input").each((index, input) => {
        $(input).attr("name", $(input).attr("name").replace("{js-newid}", newRecordIndex.toString()));
        $(input).attr("id", $(input).attr("id").replace("{js-newid}", newRecordIndex.toString()));
        $(input).val($(input).val().toString().replace("{js-newid}", newRecordIndex.toString()));
    });
    newRecord.find("select").each((index, input) => {
        $(input).attr("name", $(input).attr("name").replace("{js-newid}", newRecordIndex.toString()));
        //$(input).attr("id", $(input).attr("id").replace("{js-newid}", newRecordIndex.toString()));
    });
    newRecord.find("label").each((index, input) => {
        $(input).attr("for", $(input).attr("for").replace("{js-newid}", newRecordIndex.toString()));
    });
    // add new record
    newRecord.appendTo(".table-editable tbody")[0].scrollIntoView();
    // focus
    newRecord.find("input").not('[type="hidden"]').first().focus();
});
// delete record
$('.table-editable').on("confirmed", "[js-delete-record]", function () {
    // current row
    const currentTr = $(this).closest("tr");
    //find the previous input, which will be a hidden input for delete
    const closestInput = $(this).prev("input");
    //set its value to indicate true
    closestInput.val('True');
    // hide the row, but don't remove it.
    currentTr.hide();
});
export default undefined;
